export enum ServicesIntegration {
  itinerary = 'itinerary',
  voluntaryChange = 'voluntaryChanges',
  involuntaryChange = 'exchangeNoCost'
}
